export default __webpack_public_path__ + "static/media/gallery_07.5af02a06.jpg";